interface IProps {
  stroke?: string
  fill?: string
}

export default function IconArrowDown({ fill = '#A3A3A3' }: IProps) {
  return (
    <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M10 6L9.295 5.295L6.5 8.085V2H5.5V8.085L2.71 5.29L2 6L6 10L10 6Z' fill={fill} />
    </svg>
  )
}
